import React from "react";
import { Link, useLocation } from "react-router-dom";

/* Is file me hi poori CSS hai, to koi aur CSS pe dependency nahi.
   Grid ke liye parent me className="mcc-grid" use karna. */
const styles = `
  .mcc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 20px;
  }

  .mcc-card {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 10px;
    height: 100%;
    padding: 8px 8px 14px; /* upar-left-right kam, neeche naam ke liye zyada */
    background: var(--med-surface, #ffffff);
    border: 1px solid var(--med-border, #e2e8f0);
    border-bottom: 3px solid transparent;
    border-radius: 12px;
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      background 0.2s ease, border-color 0.2s ease;
  }
  .mcc-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 22px rgba(15, 40, 70, 0.1);
    border-color: var(--med-primary-muted, #b3dcea);
  }
  .mcc-card.active {
    background: var(--med-primary-light, #e6f5fa);
    border-color: var(--med-primary, #0a7ca5);
    border-bottom-color: var(--med-primary, #0a7ca5);
  }

  /* inner square (image) - card ki poori width */
  .mcc-img {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 8px; /* sharp corners chahiye to 0 kar do */
    overflow: hidden;
    flex-shrink: 0;
    background: #ffffff;
    border: 1px solid var(--med-border, #e2e8f0);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mcc-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.35s ease;
  }
  .mcc-card:hover .mcc-img img {
    transform: scale(1.06);
  }

  .mcc-label {
    padding: 0 6px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    text-align: center;
    color: var(--med-text-primary, #1a2333);
  }

  @media (max-width: 768px) {
    .mcc-card { padding: 6px 6px 12px; gap: 8px; }
    .mcc-label { font-size: 14px; }
  }
`;

function Card({ item }) {
  const { pathname } = useLocation();

  const slug = item?.slugPath || item?.slug;
  const to = `/categories/${slug}`;
  const isActive = pathname === to;

  return (
    <>
      <style>{styles}</style>
      <Link to={to} className={`mcc-card ${isActive ? "active" : ""}`}>
        <div className="mcc-img">
          {item?.image && <img src={item.image} alt={item?.name || "category"} />}
        </div>
        <span className="mcc-label">{item?.name}</span>
      </Link>
    </>
  );
}

export default Card;